/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycGeographicRiskAnalysisDto } from '../../models/kyc-geographic-risk-analysis-dto';

export interface SaveGeographicRiskAnalysis$Params {
  processId: string;
      body: KycGeographicRiskAnalysisDto
}

export function saveGeographicRiskAnalysis(http: HttpClient, rootUrl: string, params: SaveGeographicRiskAnalysis$Params, context?: HttpContext): Observable<StrictHttpResponse<KycGeographicRiskAnalysisDto>> {
  const rb = new RequestBuilder(rootUrl, saveGeographicRiskAnalysis.PATH, 'put');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycGeographicRiskAnalysisDto>;
    })
  );
}

saveGeographicRiskAnalysis.PATH = '/kyc/processes/{processId}/geographic-risk-analysis';
